import { FloatingNotificationButton } from "../floating-notification-button.js";

interface IntroductionVideoFloatingButtonProps {
  onClick: () => void;
  stackIndex: number;
}

export const IntroductionVideoFloatingButton = ({
  onClick,
  stackIndex,
}: IntroductionVideoFloatingButtonProps) => (
  <FloatingNotificationButton
    ariaLabel="See introduction video"
    icon={
      <svg
        className="h-6 w-6 fill-white"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Play introduction video</title>
        <path d="M8 5v14l11-7z" />
      </svg>
    }
    label="See introduction video"
    onClick={onClick}
    stackIndex={stackIndex}
  />
);
